import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AddEmployeePage.css"; // Import CSS file for styling

const AddEmployeePage = ({ selectedBusiness }) => {
    const businessId = selectedBusiness?.id;
    const navigate = useNavigate();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [dob, setDob] = useState("");
    const [doh, setDoh] = useState("");
    const [ssn, setSsn] = useState("");
    const [filingStatus, setFilingStatus] = useState("");
    const [dependents, setDependents] = useState(0);
    const [additionalFedTax, setAdditionalFedTax] = useState(0);
    const [additionalStateTax, setAdditionalStateTax] = useState(0);
    const [eStAdd, setEStAdd] = useState("");
    const [eSuite, setESuite] = useState("");
    const [eState, setEState] = useState("");
    const [eCity, setECity] = useState("");
    const [eZip, setEZip] = useState("");
    const [workType, setWorkType] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [amount, setAmount] = useState("");
    const [employerState, setEmployerState] = useState("");
    const [eCounty, setECounty] = useState(""); // NEW: State for County

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [counties, setCounties] = useState([]); // NEW: State to hold counties
    const [convenienceRuleApplies, setConvenienceRuleApplies] = useState(false);
    const [chargesCountyTax, setChargesCountyTax] = useState(false); // NEW: Track if counties are needed
    const [employerMandated, setEmployerMandated] = useState("");
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [schoolDistricts, setSchoolDistricts] = useState([]);
const [schoolDistrictNo, setSchoolDistrictNo] = useState("");



    // New states for Payment Issue Type & Direct Deposit
    const [paymentIssueType, setPaymentIssueType] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [routingNumber, setRoutingNumber] = useState("");

    const [email, setEmail] = useState("");







    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/business/${businessId}/departments`);
                setDepartments(response.data);
            } catch (error) {
                console.error("Error fetching departments:", error);
            }
        };

        fetchDepartments();
    }, [businessId]);

    


    useEffect(() => {
        const fetchEmployerState = async () => {
            try {
                const response = await api.get(`/businesses/${businessId}`);
                setEmployerState(response.data.b_state); // Assuming the response includes the employer's state
            } catch (error) {
                console.error("Error fetching employer's state:", error);
            }
        };
        fetchEmployerState();
    }, [businessId]);

    useEffect(() => {
        const checkConvenienceRule = () => {
            if (employerState) {
                const selectedState = states.find((state) => state.st_code === employerState);
                setConvenienceRuleApplies(selectedState?.convenience_rule_applies || false);
            }
        };
        checkConvenienceRule();
    }, [employerState, states]);

    // Fetch states on component mount
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const response = await api.get("/states");
                setStates(response.data);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchStates();
    }, []);


    



   
    
    
    

    // Fetch cities when a state is selected
    useEffect(() => {
        const fetchCities = async () => {
            if (eState) {
                try {
                    const response = await api.get(`/cities/${eState}`);
                    setCities(response.data);
                } catch (error) {
                    console.error("Error fetching cities:", error);
                }
            }
        };
        fetchCities();
    }, [eState]);


    useEffect(() => {
    const fetchSchoolDistricts = async () => {
        if (eState === "OH") {
            try {
                const response = await api.get("/ohio-school-districts");
                setSchoolDistricts(response.data);
            } catch (error) {
                console.error(
                    "Error fetching Ohio school districts:",
                    error
                );
            }
        } else {
            setSchoolDistricts([]);
            setSchoolDistrictNo("");
        }
    };

    fetchSchoolDistricts();
}, [eState]);

    // Fetch counties if the state charges county tax
    const fetchCounties = async (stateCode) => {
        try {
            const response = await api.get(`/counties/${stateCode}`);
            setCounties(response.data);
        } catch (error) {
            console.error("Error fetching counties:", error);
        }
    };

    const handleStateChange = (e) => {
        const selectedState = states.find((state) => state.st_code === e.target.value);
        setEState(selectedState.st_code);
        setChargesCountyTax(selectedState.charges_countytax); // Check if counties are needed

        if (selectedState.charges_countytax) {
            fetchCounties(selectedState.st_code); // Fetch counties if needed
        } else {
            setCounties([]); // Clear counties
            setECounty(""); // Reset county selection
        }
    };

    const resetForm = () => {
        setFirstName("");
        setLastName("");
        setDob("");
        setDoh("");
        setSsn("");
        setFilingStatus("");
        setDependents("");
        setAdditionalFedTax("");
        setAdditionalStateTax("");
        setEStAdd("");
        setESuite("");
        setEState("");
        setEmail("");
        setECity("");
        setECounty(""); // Reset county
        setEZip("");
        setWorkType("");
        setPaymentType("");
        setAmount("");
        setEmployerMandated("");
    };

    const handleSsnChange = (value) => {
        // Remove all non-numeric characters
        const numericValue = value.replace(/\D/g, '');

        // Format as 000-00-0000
        let formattedValue = numericValue;
        if (numericValue.length > 3) {
            formattedValue = `${numericValue.slice(0, 3)}-${numericValue.slice(3)}`;
        }
        if (numericValue.length > 5) {
            formattedValue = `${numericValue.slice(0, 3)}-${numericValue.slice(3, 5)}-${numericValue.slice(5)}`;
        }

        // Limit to 11 characters including dashes
        setSsn(formattedValue.slice(0, 11));
    };



    const handleAddDemoEmployee = async () => {
    try {
        await api.post(`/employees/demo/${businessId}`);

        alert("Demo employee added successfully!");

        navigate(`/dashboard/business/employees`);
    } catch (error) {
        console.error("Error adding demo employee:", error);
        alert("Failed to add demo employee.");
    }
};

    const handleSubmit = async (e, addAnother = false) => {
        e.preventDefault();

        if (!paymentType || !amount) {
            alert("Please select a payment type and enter the corresponding amount.");
            return;
        }

        try {
            await api.post("/employees", {
                business_id: businessId,
                first_name: firstName,
                last_name: lastName,
                hire_date: doh,
                dob,
                ssn,
                email: email ?? null, 
                filing_status: filingStatus,
                dependents,
                additional_fed_tax: additionalFedTax ?? null,
                additional_state_tax: additionalStateTax ?? null,
                e_st_add: eStAdd,
                e_suite: eSuite,
                e_state: eState,
                e_city: eCity,
                e_county: chargesCountyTax ? eCounty : null, // Include county if applicable
                school_district_no:
                    eState === "OH"
                        ? schoolDistrictNo
                        : null,
                e_zip: eZip,
                works_home: workType,
                payment_type: paymentType,
                salary_amt: paymentType === "salary" ? amount : null,
                hourly_amt: paymentType === "hourly" ? amount : null,
                employer_mandated: convenienceRuleApplies && workType === "home" ? employerMandated === "yes" : null,
                department_id: selectedDepartment ? parseInt(selectedDepartment) : null, // ✅ Include department ID
                is_direct_dep: paymentIssueType === "Direct Deposit" ? 1 : 0, // Store if employee has direct deposit
                account_number: paymentIssueType === "Direct Deposit" ? accountNumber : null,
                routing_number: paymentIssueType === "Direct Deposit" ? routingNumber : null,
            });
            console.log("Employee added successfully!");

            if (addAnother) {
                resetForm();
            } else {
                navigate(`/dashboard/business/employees`);
            }
        } catch (error) {
            console.error("Error adding employee:", error);
            alert("Failed to add employee.");
        }
    };

    return (
        <div className="add-employee-container">
            <h3 className="page-title">Add Employee</h3>
            <div className="demo-add">
            <button onClick={handleAddDemoEmployee}>
    Add Demo Employee
</button>
</div>
            <form
                className="add-employee-form"
                onSubmit={(e) => handleSubmit(e, false)}
            >


            {/* Department Select Box */}
            <label className="addemplabel">
                    Department:
                    <select
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                        required={departments.length > 0}
                        disabled={departments.length === 0}
                    >
                        <option value="">Select Department</option>
                        {departments.map((dept) => (
                            <option key={dept.id} value={dept.id}>
                                {dept.department_name}
                            </option>
                        ))}
                    </select>
                </label>

                {/* Payment Issue Type Dropdown */}
                <label className="addemplabel">
                    Payment Issue Type:
                    <select value={paymentIssueType} onChange={(e) => setPaymentIssueType(e.target.value)} required>
                        <option value="">Select Payment Issue Type</option>
                        <option value="Print Paycheck">Print Paycheck</option>
                        <option value="Direct Deposit">Direct Deposit</option>
                    </select>
                </label>

                {/* Show Direct Deposit Fields if Direct Deposit is Selected */}
                {paymentIssueType === "Direct Deposit" && (
                    <>
                        <label className="addemplabel">
                            Account Number:
                            <input type="text" value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} required />
                        </label>
                        <label className="addemplabel">
                            Routing Number:
                            <input type="text" value={routingNumber} onChange={(e) => setRoutingNumber(e.target.value)} required />
                        </label>
                    </>
                )}           


                <label className="addemplabel">
                    First Name:
                    <input
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                    />
                </label>
                <label className="addemplabel">
                    Last Name:
                    <input
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        required
                    />
                </label>
                <label className="addemplabel">
                    Date of Hire:
                    <input
                        value={doh}
                        onChange={(e) => setDoh(e.target.value)}
                        type="date"
                        required
                    />
                </label>
                <label className="addemplabel">
                    Date of Birth:
                    <input
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        type="date"
                        required
                    />
                </label>
                <label className="addemplabel">
                    Email:   (*optional*)
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </label>

                <label className="addemplabel">
                    SSN:
                    <input
                        value={ssn}
                        onChange={(e) => handleSsnChange(e.target.value)}
                        required
                        maxLength={11} // Limits input to the SSN format length (including dashes)
                    />
                </label>
                <label className="addemplabel ">
                    Filing Status:
                    <select
                        value={filingStatus}
                        onChange={(e) => setFilingStatus(e.target.value)}
                        required
                    >
                        <option value="">Select Filing Status</option>
                        <option value="Single">Single</option>
                        <option value="Married">Married</option>
                        <option value="Head of Household">Head of Household</option>
                    </select>
                </label>
                <label className="addemplabel">
                    Dependents:
                    <input
                        value={dependents}
                        onChange={(e) => setDependents(e.target.value)}
                        type="number"
                    />
                </label>
                <label className="addemplabel ">
                    Additional Federal Tax:
                    <input
                        value={additionalFedTax}
                        onChange={(e) => setAdditionalFedTax(e.target.value)}
                        type="number"
                    />
                </label>
                <label className="addemplabel ">
                    Additional State Tax:
                    <input
                        value={additionalStateTax}
                        onChange={(e) => setAdditionalStateTax(e.target.value)}
                        type="number"
                    />
                </label>
                <label className="addemplabel">
                    Street Address:
                    <input
                        value={eStAdd}
                        onChange={(e) => setEStAdd(e.target.value)}
                        required
                    />
                </label>
                <label className="addemplabel">
                    Suite (Optional):
                    <input
                        value={eSuite}
                        onChange={(e) => setESuite(e.target.value)}
                    />
                </label>
                <label className="addemplabel">
                    State:
                    <select
                        value={eState}
                        onChange={handleStateChange}
                        required
                    >
                        <option value="">Select State</option>
                        {states.map((state) => (
                            <option key={state.st_code} value={state.st_code}>
                                {state.st_name}
                            </option>
                        ))}
                    </select>
                </label>

                {/* NEW: Add county dropdown if chargesCountyTax is true */}
                {chargesCountyTax === 1 && (
                    <label className="addemplabel">
                        County:
                        <select
                            value={eCounty}
                            onChange={(e) => setECounty(e.target.value)}
                            required
                        >
                            <option value="">Select County</option>
                            {counties.map((county, index) => (
                                <option key={index} value={county.county_name}>
                                    {county.county_name}
                                </option>
                            ))}
                        </select>
                    </label>
                )}


                {eState === "OH" && (
    <label className="addemplabel">
        School District:
        <select
            value={schoolDistrictNo}
            onChange={(e) =>
                setSchoolDistrictNo(e.target.value)
            }
            required
        >
            <option value="">
                Select School District
            </option>

            {schoolDistricts.map((district) => (
                <option
                    key={district.district_number}
                    value={district.district_number}
                >
                    {district.district_name}
                    {" - "}
                    {district.district_number}
                </option>
            ))}
        </select>
    </label>
)}

                <label className="addemplabel address-row">
                    City:
                    <select
                        value={eCity}
                        onChange={(e) => setECity(e.target.value)}
                        required
                    >
                        <option value="">Select City</option>
                        {cities.map((city, index) => (
                            <option key={index} value={city.city_name}>
                                {city.city_name}
                            </option>
                        ))}
                    </select>
                </label>
                <label className="addemplabel address-row">
                    ZIP Code:
                    <input
                        value={eZip}
                        onChange={(e) => setEZip(e.target.value)}
                        required
                    />
                </label>
                <label className="workhomelabel">
                    Work Location:
                    <select
                        value={workType}
                        onChange={(e) => setWorkType(e.target.value)}
                        required
                    >
                        <option value="">Work Location</option>
                        <option value="bus">Works at business location</option>
                        <option value="home">Works from home</option>
                    </select>
                </label>
                {convenienceRuleApplies && workType === "home" && (
                    <label className="addemplabel">
                        Is Remote Work Employer-Mandated?
                        <select
                            value={employerMandated}
                            onChange={(e) => setEmployerMandated(e.target.value)}
                            required
                        >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                        </select>
                    </label>
                )}
                <label className="addemplabel">
                    Payment Type:
                    <select
                        value={paymentType}
                        onChange={(e) => setPaymentType(e.target.value)}
                        required
                    >
                        <option value="">Select Payment Type</option>
                        <option value="salary">Salary</option>
                        <option value="hourly">Hourly</option>
                    </select>
                </label>
                {paymentType && (
                    <label className="addemplabel">
                        {paymentType === "salary" ? "Salary per year" : "Hourly Rate"}:
                        <input
                            className="wages"
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            required
                        />
                    </label>
                )}
                <div className="form-buttons-add">
                    <button className="save-button-add" type="submit">
                        Add Employee
                    </button>
                    <button
                        className="save-button-add"
                        type="button"
                        onClick={(e) => handleSubmit(e, true)}
                    >
                        Add and Add Another
                    </button>
                    <button
                        className="cancel-button-add"
                        type="button"
                        onClick={() => navigate(`/dashboard/business/employees`)}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddEmployeePage;



